import { useCallback } from 'react';
import axiosInstance from '../../../axiosInstance';

/**
 * useWorkflowApi Hook
 *
 * Pure API hook for workflow operations.
 *
 * @returns {Object} - { getWorkflowVersion, getEndUserWorkflowVersion, getAllWorkflows }
 */
const useWorkflowApi = () => {
  const getWorkflowVersion = useCallback(async (versionId) => {
    const response = await axiosInstance.get(
      `/api/workflows/version/${versionId}`
    );
    return response.data;
  }, []);

  const getEndUserWorkflowVersion = useCallback(async (versionId) => {
    const response = await axiosInstance.get(
      `/api/workflows/endUser/version/${versionId}`
    );
    return response.data;
  }, []);

  const getEndUserRequest = useCallback(async (requestId) => {
    const response = await axiosInstance.get(
      `/api/requests/enduser/${requestId}`
    );
    return response.data;
  }, []);

  const getAllWorkflows = useCallback(async () => {
    const response = await axiosInstance.get('/api/workflows');
    return response.data;
  }, []);

  return {
    getWorkflowVersion,
    getEndUserWorkflowVersion,
    getEndUserRequest,
    getAllWorkflows,
  };
};

export default useWorkflowApi;
